export enum HttpStatusCode { 
    OK = 200,
    NotFound = 404,
    BadRequest = 400,
    Unauthorized = 401,
    Forbidden = 403,
    InternalServerError = 500,
    ServiceUnavailable = 503,
    GatewayTimeout = 504,
    TooManyRequests = 429,
}